import styled, { css } from 'styled-components';

interface ContainerProps {
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
}

interface IBoxTagProps {
  color: string;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 10px;
  border: 1px solid #d3d3d3;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 52px;

  + div {
    margin-top: 8px;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;

    .button-show {
      width: 70px;
      font-size: 12px;
      text-align: center;
      background: none;
      border: 0;
      padding: 6px 6px 6px;
      color: #01cc9d !important;
      height: 52px;
      font-weight: bold;
    }
  }

  input {
    width: 100%;
    flex: 1;
    background: transparent;
    border: 0;
    color: #8692a6;
    transition-duration: 0.2s;

    ::placeholder {
      color: #d3d3d3;
    }

    :focus {
      border: none;
      outline: 0;
    }
  }

  svg {
    margin-right: 16px;
    color: #8692a6;
    transition-duration: 0.2s;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) => props.isFilled && css``}

  ${(props) =>
    props.isFocuses &&
    css`
      color: #606060;
      border-color: #606060;
    `}
`;

export const GroupBox = styled.div`
  input {
    min-width: 50px;
  }
`;

export const BoxTag = styled.div<IBoxTagProps>`
  background-color: ${(props) => props.color}0a;
  width: max-content !important;
  margin: 5px 14px 5px 0;

  ::before {
    content: '';
    background-color: ${(props) => props.color};
    height: 13px;
    width: 13px;
    border-radius: 14px;
  }
`;
